import React from 'react';
import JoinTeamPage from '../components/JoinTeamPage';
import WhatsAppButton from '../components/WhatsAppButton';

function JoinUs() {
  return (
    <div className="home">
      <JoinTeamPage />
      <WhatsAppButton />
    </div>
  );
}

export default JoinUs;
